/**
 * Modèle des types de question de formulaire.
 * `key` = identifiant interne de l'éditeur, `value` = valeur stockée en base.
 */

export const FORM_TYPES = {
    short: { value: '4', label: 'forms.type.short', order: 1 },
    long: { value: '9', label: 'forms.type.long', order: 2 },
    number: { value: '5', label: 'forms.type.number', order: 3 },
    radio: { value: '2', label: 'forms.type.radio', order: 4 },
    checkbox: { value: '1', label: 'forms.type.checkbox', order: 5 },
    select: { value: '3', label: 'forms.type.select', order: 6 },
    date: { value: '7', label: 'forms.type.date', order: 7 },
    experience: { value: '10', label: 'forms.type.experience', order: 8 },
}

export const FORM_TYPE_KEYS = Object.keys(FORM_TYPES)

const DB_VALUE_TO_KEY = {
    1: 'checkbox',
    2: 'radio',
    3: 'select',
    4: 'short',
    5: 'number',
    6: 'date',
    7: 'date',
    8: 'date',
    9: 'long',
    10: 'experience',
}

/**
 * Convertit une valeur stockée en base vers la clé interne de l'éditeur.
 * @param {string|number} value
 * @returns {string}
 */
export function typeKeyFromDbValue(value) {
    if (value === undefined || value === null) return 'short'
    return DB_VALUE_TO_KEY[String(value)] || 'short'
}
